import React from 'react';

import {
  FaBox,
  FaDollyFlatbed,
  FaMoneyBillWave,
  FaListAlt,
  FaFolder,
  FaBoxOpen,
  FaCalendarAlt,
} from 'react-icons/fa';

export default {
  Displays: {
    icon: <FaBox size={30} />,
    link: '/items/displays',
    perm: 'items_displays',
  },
  Materiais: {
    icon: <FaDollyFlatbed size={30} />,
    link: '/items/materials',
    perm: 'items_materials',
  },
  Pagamentos: {
    icon: <FaMoneyBillWave size={30} />,
    link: '/items/sponsorships',
    perm: 'items_sponsorships',
  },
  Problemas: {
    icon: <FaListAlt size={30} />,
    link: '/items/adversities',
    perm: 'items_adversities',
  },
  Pastas: {
    icon: <FaFolder size={30} />,
    link: '/items/folders',
    perm: 'items_folders',
  },
  Amostras: {
    icon: <FaBoxOpen size={30} />,
    link: '/items/samples',
    perm: 'items_samples',
  },
  Eventos: {
    icon: <FaCalendarAlt size={30} />,
    link: '/items/events',
    perm: 'items_events',
  },
};
